import './tabs-content.scss'

const selectors = {
  tabs: '[data-tabs]',
  tabsContainer: '[data-tabs-container]',
  underline: '[data-tabs-underline]',
  tab: '[data-tabs-tab]',
  pane: '[data-tabs-pane]',
  active: 'active',
}

const showIsScrollable = (inner, container) => {
  const containerWidth = inner.getBoundingClientRect().width
  const scrollWidth = inner.scrollWidth

  const isLeftAvailable = !!inner.scrollLeft
  const isRightAvailable = inner.scrollLeft < scrollWidth - containerWidth
  const isLeftActive = container.classList.contains('scrollable_left')
  const isRightActive = container.classList.contains('scrollable_right')

  if (!isLeftAvailable && isLeftActive) container.classList.remove('scrollable_left')
  if (!isRightAvailable && isRightActive) container.classList.remove('scrollable_right')
  if (isLeftAvailable && !isLeftActive) container.classList.add('scrollable_left')
  if (isRightAvailable && !isRightActive) container.classList.add('scrollable_right')
}

const initScrollable = (container) => {
  const inner = container.querySelector(':scope > *')

  inner.addEventListener('scroll', (_) => showIsScrollable(inner, container))

  showIsScrollable(inner, container)
}

const handleTabClick = (tabs, panes, underline, activeIndex) => {
  tabs.forEach((tab, index) => tab.classList[index === activeIndex ? 'add' : 'remove'](selectors.active))
  panes.forEach((tab, index) => tab.classList[index === activeIndex ? 'add' : 'remove'](selectors.active))

  underline.style.width = tabs[activeIndex].clientWidth + 'px'
  underline.style.left = tabs[activeIndex].offsetLeft + 'px'
}

const initTabsContent = (container) => {
  const tabs = container.querySelectorAll(selectors.tab)
  const panes = container.querySelectorAll(selectors.pane)
  const underline = container.querySelector(selectors.underline)

  const tabsContainer = container.querySelector(selectors.tabsContainer)

  if (!tabs.length) return

  tabs.forEach((tab, index) => tab.addEventListener('click', () => handleTabClick(tabs, panes, underline, index)))

  handleTabClick(tabs, panes, underline, 0)
  initScrollable(tabsContainer)
}

document.addEventListener('DOMContentLoaded', async function () {
  const containers = document.querySelectorAll(selectors.tabs)

  containers?.forEach(initTabsContent)
})
